
'use strict';

define('component!Spinner',['require','lib/prototype/String.prototype','react','create-react-class','lib/Podio.Config'],function (require) {
  'use strict';

  require('lib/prototype/String.prototype');

  var React = require('react');
  var ReactCreateClass = require('create-react-class');

  var podioConfig = require('lib/Podio.Config');

  var Loaders = {
    'normal': 'loader',
    'dark': 'loader-dark',
    'grey': 'loader-grey',
    'big': 'loader-big'
  };

  var SpinnerComponent = ReactCreateClass({
    displayName: 'SpinnerComponent',

    getDefaultProps: function getDefaultProps() {
      return {
        loader: 'normal',
        useWrapper: true
      };
    },

    render: function render() {
      if (this.props.useWrapper) {
        return React.createElement(
          'div',
          { className: 'spinner-wrapper' },
          this.renderSpinner()
        );
      }

      return this.renderSpinner();
    },

    renderSpinner: function renderSpinner() {
      var loader = '{0}.gif'.format(Loaders[this.props.loader]);

      return React.createElement('img', { className: 'spinner', src: '{0}/images/{1}'.format(podioConfig.asset_host, loader) });
    }
  });

  return SpinnerComponent;
});
